<template>
  <div>
    <div class="tile is-ancestor">
      <div class="tile is-parent is-4">
        <grid-box :title="'Behörighet'">
          <table v-if="permissions" class="table is-narrow">
            <tr v-for="permission in permissions" :key="permission.key">
              <td>{{ permission.value }}</td>
              <td class="has-text-right">
                <input :id="'permissions-' + permission" :checked="hasPermission(permission.key)" type="checkbox" class="switch is-rounded is-small" disabled>
                <label :for="'permissions-' + permission" class="label active-switch"></label>
              </td>
            </tr>
          </table>
        </grid-box>
      </div>
      <div class="tile is-parent is-4">
        <grid-box :title="'Användare'">
          <table v-if="userRoles" class="table is-narrow">
            <tr v-for="userRole in userRoles" :key="userRole.role"><td>{{ userRole.role }}</td><td>{{ userRole.numberOfUsers }}</td></tr>
          </table>
          <router-link to="/superadmin/users" v-if="hasPermission('EditUsers')">Redigera användare</router-link>
        </grid-box>
      </div>
      <div class="tile is-parent is-4">
        <grid-box :title="'Mättal'">
          <table v-if="tableMetrics" class="table is-narrow">
            <tr v-for="tableMetric in tableMetrics" :key="tableMetric.table"><td>{{ tableMetric.table }}</td><td>{{ tableMetric.numberOfRecords }}</td></tr>
          </table>
        </grid-box>
      </div>
    </div>
    <div class="tile is-ancestor">
      <div class="tile is-parent is-12">
        <grid-box :title="'Länkar'">
          <div><a href="http://blabla.com">Någon länk</a></div>
          <div><a href="http://blabla.com">Någon länk</a></div>
        </grid-box>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import GridBox from '@/components/boxes/GridBox'

export default {
  components: {
    GridBox
  },

  data () {
    return {
      tab: 'metrics',
      roles: null,
      permissions: null,
      tableMetrics: null,
      userRoles: null
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),

    ...mapGetters('auth', ['hasPermission'])
  },

  methods: {
    ...mapActions('meta', ['getRoles', 'getPermissions', 'getDatabaseTableMetrics', 'getUserRoleMetrics'])
  },

  created () {
    this.getRoles().then(roles => {
      this.roles = roles.result
    })

    this.getPermissions().then(permissions => {
      this.permissions = permissions
    })

    this.getDatabaseTableMetrics().then(tableMetrics => {
      this.tableMetrics = tableMetrics
    })

    this.getUserRoleMetrics().then(userRoles => {
      this.userRoles = userRoles
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/Dashboard/StaffViews/Metrics.vue